import { useStaticQuery } from "gatsby";
export default () => { const data = useStaticQuery("3166865542"); return data; };
